import { Navigate, useLocation } from "react-router-dom";

import { RVRoutingPage } from "@regal-voice/ui";
import { usePageAvailability } from "App/routes/Hooks/usePageAvilability/usePageAvailability";
import { createRerouteRegex } from "App/routes/pageNames";
import { AppPagePaths } from "App/routes/paths";
import { orchestrationPathResources } from "Pages/orchestration/Pages/orchestrationPaths";
import { useOrchestrationPathing } from "Pages/orchestration/useOrchestrationPathing";

import { SettingsPaths } from "./paths";
import { SettingsSideNavBar } from "./SettingsSideNavBar/SettingsSideNavBar";
export default function SettingsRoutingPage(): JSX.Element {
    const { showSettings } = usePageAvailability();

    if (!showSettings) {
        return <Navigate to={AppPagePaths.fallback} />;
    }

    return <RVRoutingPage nav={<SettingsSideNavBar />} />;
}

export function SettingsRerouter(): JSX.Element {
    const location = useLocation();
    const { ivrsBasePath, routingRulesBasePath } = useOrchestrationPathing();
    const pathAfterSettings = location.pathname.replace(createRerouteRegex(AppPagePaths.settings), "");

    // Map old settings paths to new orchestration paths
    if (
        pathAfterSettings === orchestrationPathResources.ivrs ||
        pathAfterSettings.startsWith(`${orchestrationPathResources.ivrs}/`)
    ) {
        const remainingPath = pathAfterSettings.substring(orchestrationPathResources.ivrs.length).replace(/^\//, "");
        const newPath = remainingPath
            ? `${ivrsBasePath}/${remainingPath}${location.search}${location.hash}`
            : `${ivrsBasePath}${location.search}${location.hash}`;
        return <Navigate to={newPath} replace />;
    }

    if (
        pathAfterSettings === SettingsPaths.routingRules ||
        pathAfterSettings.startsWith(`${SettingsPaths.routingRules}/`)
    ) {
        const remainingPath = pathAfterSettings.substring(SettingsPaths.routingRules.length).replace(/^\//, "");
        // routingRulesBasePath already includes /rules (e.g., "/orchestration/routing-rules/rules")
        // When we have a different subpath like "queues", we need to strip the last segment (/rules)
        // using the regex /\/[^/]+$/ (matches last "/" + non-slash chars) and replace it with the actual path
        const newPath = remainingPath
            ? `${routingRulesBasePath.replace(/\/[^/]+$/, "")}/${remainingPath}${location.search}${location.hash}`
            : `${routingRulesBasePath}${location.search}${location.hash}`;
        return <Navigate to={newPath} replace />;
    }

    // Default: if no specific reroute found, just go to settings
    const newPath = `${AppPagePaths.settings}${location.search}${location.hash}`;
    return <Navigate to={newPath} replace />;
}
